const doc = [({"da":({"js":({"admin":({"activities":({"participants":({"index":({"participants":"Deltagere"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;